import { Component } from '@angular/core';
import { ModalService } from '../../modules/modal/modal.service';

import { Message } from '../../models';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './change-container-modal.component.html',
})
export class ChangeContainerModal {
  data: Message;
  success: Function;
  cancel: Function;
  ok: boolean;

  constructor(
    private _modalService: ModalService
  ) {}

  async onOkClicked(): Promise<void> {
    if (this.success) {
      this.ok = true;
      this.success();
    } else {
      this._modalService.closeModal();
    }
  }

  onCancelClicked(): void {
    if (this.cancel) {
      this.cancel();
      this._modalService.closeModal();
    }
  }
}
